import { createSlice } from "@reduxjs/toolkit";


export const fromOptions = createSlice({
    name: "@@Form",
    initialState: {
        field: {},
        files: {},
    },
    reducers: {
        formDestroy: (state, action) => {
            state.field = {};
        },
        formChange: (state, action) => {
            state.field = {
                ...state.field,
                [action.payload.name]: action.payload.value
            };
        },
        formFilesDestroy: (state, action) => {
            state.files = {};
        },
        formFilesChange: (state, action) => {
            state.files = {
                ...state.files,
                [action.payload.name]: action.payload.value
            };
        },
    },
});

export const { formDestroy, formChange, formFilesDestroy, formFilesChange } = fromOptions.actions;

export default fromOptions.reducer;